import BottomNavigationAction from '@mui/material/BottomNavigationAction'
import BottomNavigation from '@mui/material/BottomNavigation'
import { useMediaQuery, useTheme } from '@mui/material'
import { Outlet, useNavigate } from 'react-router-dom'
import { History, Menu, Save } from '@mui/icons-material'
import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'

import background from 'assets/svg/background.png'

import MobileSidebar from '../MobileSidebar'
import Sidebar from '../Sidebar'
import Header from '../Header'
import Footer from '../Footer'

function Main() {
   const [sidebar, handleSidebar] = useState(true)
   const theme = useTheme()
   const navigate = useNavigate()
   const isMobile = useMediaQuery(theme.breakpoints.down('lg'))

   function handleSidebarChange(open: boolean) {
      handleSidebar(open)
      if (!isMobile) {
         if (open === true) {
            window.localStorage.setItem('sidebarVariant', 'opened')
         } else window.localStorage.setItem('sidebarVariant', 'closed')
      }
   }

   useEffect(() => {
      if (!isMobile) {
         const shouldCloseTab = window.localStorage.getItem('sidebarVariant') === 'closed'
         if (shouldCloseTab) {
            handleSidebar(false)
         }
      }
   }, [])

   return (
      <>
         <Header openSidebar={sidebar && isMobile} />
         <Box component="main" display="flex" minHeight="calc(100vh - 139px)" mt={8}>
            {isMobile ? (
               <MobileSidebar open={sidebar} handleClose={() => handleSidebarChange(false)} />
            ) : (
               <Sidebar open={sidebar} handleOpen={handleSidebarChange} />
            )}
            <Box
               sx={{
                  px: { xs: 1, md: 5 },
                  py: { lg: 5, md: 5, xs: 2 },
                  flexGrow: 1,
                  overflow: 'scroll',
                  backgroundImage: `url(${background})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPositionX: 'center',
                  backgroundPositionY: 'center',
                  backgroundColor: '',
                  backgroundSize: 'cover',
               }}
            >
               <Outlet />
            </Box>
         </Box>
         <Footer open={sidebar} />
         {isMobile && (
            <BottomNavigation
               sx={{
                  position: 'sticky',
                  bottom: 0,
                  cursor: 'pointer',
                  left: 0,
                  right: 0,
                  height: '60px',
                  borderTop: `3px solid ${theme.palette.primary.main}`,
                  zIndex: 100,
                  width: '100%',
               }}
            >
               <BottomNavigationAction
                  sx={{ p: '0px 12px 16px 12px', cursor: 'pointer' }}
                  onClick={() => handleSidebarChange(true)}
                  icon={<Menu sx={{ fontSize: 25 }} />}
               />
               <BottomNavigationAction
                  sx={{ p: '0px 12px 16px 12px', cursor: 'pointer' }}
                  onClick={() => navigate('/dashboard/saved-carts')}
                  icon={<Save sx={{ fontSize: 25 }} />}
               />
               <BottomNavigationAction
                  sx={{ p: '0px 12px 16px 12px', cursor: 'pointer' }}
                  onClick={() => navigate('/dashboard/orders-history')}
                  icon={<History sx={{ fontSize: 25 }} />}
               />
            </BottomNavigation>
         )}
      </>
   )
}

export default Main
